import axios from 'axios';
import { secureStorage } from '../utils/secureStorage';
import { BACKEND_URL } from '../utils/backendUrl';

const API_BASE = `${BACKEND_URL}/api/v3`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = secureStorage.getItem('nexus_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Communications API Client
 * Handles Templates, Prefill, and related endpoints
 */
export const communicationsApi = {
  // Templates endpoints
  templates: {
    list: async (params = {}) => {
      const response = await apiClient.get('/templates/', { params });
      return response.data;
    },
    
    get: async (templateId) => {
      const response = await apiClient.get(`/templates/${templateId}`);
      return response.data;
    },
    
    create: async (templateData) => {
      const response = await apiClient.post('/templates/', templateData);
      return response.data;
    },
    
    update: async (templateId, templateData) => {
      const response = await apiClient.put(`/templates/${templateId}`, templateData);
      return response.data;
    },
    
    delete: async (templateId) => {
      const response = await apiClient.delete(`/templates/${templateId}`);
      return response.data;
    },
    
    health: async () => {
      const response = await apiClient.get('/templates/health');
      return response.data;
    }
  },
  
  // Prefill & Preview endpoints
  prefill: {
    get: async (packId, event, lang = 'en') => {
      const response = await apiClient.get('/communications/prefill', {
        params: { pack_id: packId, event, lang }
      });
      return response.data;
    },
    
    preview: async (templateId, tokens = {}) => {
      const response = await apiClient.post('/communications/preview', null, {
        params: { template_id: templateId },
        data: tokens
      });
      return response.data;
    },
    
    health: async () => {
      const response = await apiClient.get('/communications/health');
      return response.data;
    }
  },
  
  // Broadcast helper endpoints (from existing broadcast_helper_routes)
  broadcast: {
    generateDeeplink: async (announcementId, messageData) => {
      const response = await apiClient.post('/broadcast/deeplink', messageData);
      return response.data;
    },
    
    downloadVCF: async (announcementId) => {
      const response = await apiClient.post('/broadcast/vcf', 
        { announcement_id: announcementId },
        { responseType: 'blob' }
      );
      return response.data;
    },
    
    markAsSent: async (announcementId, notes = '') => {
      const response = await apiClient.post(`/broadcast/${announcementId}/mark-sent`, {
        notes
      });
      return response.data;
    },
    
    getStatus: async (announcementId) => {
      const response = await apiClient.get(`/broadcast/${announcementId}/status`);
      return response.data;
    },
    
    getClicks: async (announcementId) => {
      const response = await apiClient.get(`/broadcast/${announcementId}/clicks`);
      return response.data;
    }
  }
};

export default communicationsApi;
